// Copyright (c) 2023-present VexFlow contributors: https://github.com/vexflow/vexflow/graphs/contributors
import { Stave } from './stave';
import { Category } from './typeguard';
export class TabStave extends Stave {
    static get CATEGORY() {
        return Category.TabStave;
    }
    constructor(x, y, width, options) {
        const tabOptions = Object.assign({ spacingBetweenLinesPx: 13, numLines: 6, topTextPosition: 1 }, options);
        super(x, y, width, tabOptions);
    }
    getYForGlyphs() {
        return this.getYForLine(2.5);
    }
    // Deprecated
    addTabGlyph() {
        this.addClef('tab');
        return this;
    }
}
